import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Window from '../../generic-components/contracting-window';
import ExportIcon from 'material-ui/svg-icons/content/next-week';
import RedDot from '../../../tc-ui/redDot';
import HotelIcon from 'material-ui/svg-icons/maps/hotel';
import ExploreIcon from 'material-ui/svg-icons/action/explore';
import { FlatButton, IconButton, FontIcon, IconMenu, MenuItem } from 'material-ui';
import InternalNoteIcon from 'material-ui/svg-icons/action/speaker-notes';
import { push as pushAction } from 'react-router-redux';
import LeftNav from '../left-nav/left-nav';
import moment from 'moment';
import R from 'ramda';
import ContractMailbox from '../../generic-components/contractMailbox';
import ExportTourWriter from '../../generic-components/exportTourWriter';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
import RequestDataLoadingIcon from 'material-ui/svg-icons/action/markunread-mailbox';
import querystring from 'query-string';
import WallWrapper from '../../../wall/wrapper';

const WindowDataWrapper = ({
  routeName,
  children,
  actionsForLeftNav,
  actionsForContractWindow,
  // reducer -> leftNav data
  supplierInfo = {},
  buyerChecked,
  files,
  state,
  rateConversionSetting,
  contractState,
  locationId,
  contractId,
  locationName,
  startDate,
  endDate,
  hasNewComments,
  hasDraft,
  templateId,
  draftMagicLink,
  amended,
  isLatest,
  versions,
  allVersions,
  email,
  partners = [],
  isSender,
  from = {},
  to = {},
  viewingAs,
  templateFromDummy,
  buyerHasDraftId,
  rateContainer = {},
  // reducer -> rightsideContent data
  productType,
  productName,
  productId,
  // userReducer
  tourPlanUser,
  push,
  buyerId,
  requestDataLoading,
  pureDocView,
  openRateDocIframe,
}) => {
  const mainTitleStyle = {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
  const bgColor = (() => {
    if (!isLatest) return '#373737';
    if (templateFromDummy) return '#00bcd447';
    return '#00a1ba';
  })();
  const textColor = (() => {
    if (templateFromDummy) return 'rgba(0, 0, 0, 0.64)';
    return '#fff';
  })();
  const requestDL = () => requestDataLoading({ contractId, files });
  const acceptedOrLoaded = contractState === 'accepted' || contractState === 'loading' || contractState === 'loaded';
  const openDraft = () => {
    openRateDocIframe({
      url: `${draftMagicLink}&jumpBackTo=${window.location.href}`,
      collection: 'draft',
      rateDocId: buyerHasDraftId,
      isInSigning: false,
    });
  };
  const contractHasA = (() => {
    if ((hasDraft && viewingAs === 'Supplier')) {
      return <span>&nbsp;&nbsp;&nbsp;This contract has an <Link to={`/contracting/draft/${contractId}/details`} style={{ color: 'red' }}>unfinished draft</Link>.</span>;
    } else if (viewingAs === 'Buyer' && buyerHasDraftId) {
      return (<span>&nbsp;&nbsp;&nbsp;This contract has an <span onClick={openDraft} style={{ color: 'red', cursor: 'pointer' }}>unfinished draft</span>.</span>);
    }
    // if (amendedFromId) return <span>This {isInitialAmendmentDraft ? 'draft' : 'amendment'} was created from this<a href={`/contracting/contract/${amendedFromId}/details`}> contract</a>.</span>;
  })();
  const buttonLabelStyle = { textTransform: 'none', paddingRight: '8px' };
  const buttonStyle = { color: textColor, minWidth: '68px', flex: '0 0 auto' };
  const titleName = R.pathOr(isSender ? to.name : from.name, [0, 'name'], partners);
  const partnerDetailsLink = (() => {
    const url = `${process.env.NEW_SYSTEM_URL}/partner-management/partner-details/${R.pathOr('', [0, 'id'], partners)}?jwt=${localStorage.getItem('jwt')}`;
    // TODO: use below after we have contactDetails page
    // const url = partners.length === 1
    //   ? `/partnerDetails/${R.pathOr('', [0, 'id'], partners)}`
    //   : `/contactDetails/${R.pathOr('', [0, 'id'], contacts)}`;
    return (
      <span
        style={{ cursor: 'pointer' }}
        onClick={() => window.location = url}
      >
        {titleName}
      </span>
    );
  })();
  return (
    <Window
      leftNavNode={<LeftNav
        {...actionsForLeftNav}
        textColor={textColor}
        headerStyle={{
          backgroundColor: bgColor,
          color: textColor,
          // borderTop: templateFromDummy ? `1px solid ${textColor}` : 'none',
          // borderBottom: templateFromDummy ? `1px solid ${textColor}` : 'none',
        }}
        leftNavTitle="Back to Rates & Contracts"
      />}
      textColor={textColor}
      headerStyle={{
        backgroundColor: bgColor,
        color: textColor,
        // border: templateFromDummy ? `1px solid ${textColor}` : 'none',
      }}
      title={
        // getMainTitle(companyName || email || '', locationName || '')
        !locationName || titleName === locationName ? (
          <div
            style={{ ...mainTitleStyle, lineHeight: '48px' }}
          >{partnerDetailsLink} {supplierInfo.marketInfo ? `(${supplierInfo.marketInfo})` : ''}</div>
        ) : (
          <div>
            <div style={mainTitleStyle}>{partnerDetailsLink}</div>
            <div style={mainTitleStyle}>{locationName} {supplierInfo.marketInfo ? `(${supplierInfo.marketInfo})` : ''}</div>
          </div>
        )
      }
      subtitle={{
        hideBottomBorder: routeName === 'activities',
        dateRange: `${moment.utc(startDate).format('D MMM YYYY')} - ${moment.utc(endDate).format('D MMM YYYY')}`,
        name: (<div style={{ display: 'flex', alignItems: 'center' }}>
          {Boolean(productId && productType === 'Accommodation') && <HotelIcon/>}
          {Boolean(productId && productType === 'Non-Accommodation') && <ExploreIcon/>}
          <a href={`/product/${productId}`} target="_blank" style={{ marginLeft: productId ? '12px' : '0', display: 'inline-block', maxWidth: '200px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
            {productName}
          </a>
        </div>),
        secondLineSubtitle: (
          <div className="flex-tc-sb" style={{ display: locationId && (contractHasA) ? 'flex' : 'none', lineHeight: '24px', padding: '0 24px', fontSize: '14px' }}>
            <div/>
            <div>
            {contractHasA}
            </div>
          </div>),
          // don't want to show version number to confuse read only supplier
          // also should not show version number for contract request, because it's one to many relationship
          // we are displaying all rate contracts for this request, no need to show versions
        versions: !pureDocView
        && locationId
        && ((isLatest && versions && versions.length > 1)
        || (!isLatest && !isNilOrEmpty(allVersions))) ? (
          <IconMenu
            desktop
            style={{ marginLeft: '4px', cursor: 'pointer' }}
            iconButtonElement={<IconButton style={{ fontSize: '12px', padding: '0', width: '100%', height: '30px' }}><a>{`Version ${versions.length}`}</a></IconButton>}
          >
            {
              (isLatest ? versions : allVersions).map((version, i) => (
                <MenuItem
                  key={i}
                  disabled={version === contractId}
                  primaryText={(() => {
                    if (rateContainer && !i) {
                      if (viewingAs === 'Buyer') return `${rateContainer.partnerName} ${rateContainer.year} contracting workspace`;
                      return 'Rate Request';
                    }
                    return `Version ${i + 1}`;
                  })()}
                  onClick={() => actionsForContractWindow.changeLeftNavRoute(`/contracting/contract/${version}/details`)}
                />))
            }
          </IconMenu>
        ) : ``,
      }}
      titleBarRightWidgets={(pureDocView ? [] : [
        <IconMenu key="moreAction" iconButtonElement={<IconButton iconClassName="tc-icon-more-vert" iconStyle={{ color: textColor, fontSize: '22px', marginLeft: '8px' }} />}>
          {
            viewingAs === 'Buyer'
            && isLatest
            && !locationId
            && buyerChecked
            ? <MenuItem
              key="requestDL"
              style={{ fontSize: '15px', minHeight: '32px', lineHeight: '32px' }}
              innerDivStyle={{ padding: '0px 24px 0px 64px' }}
              primaryText="Submit this workspace for data loading"
              onTouchTap={requestDL}
              disabled={['loading', 'loaded', 'rejected'].indexOf(state) > -1 
                  || ['defer', 'opt-out'].indexOf(rateConversionSetting) < 0 }
              leftIcon={<RequestDataLoadingIcon
                style={{
                  top: '4px',
                  margin: '0',
                  left: '24px',
                  fill: 'rgb(117, 117, 117)',
                }}
              />}
            /> : undefined
          }
          {
            Boolean(isLatest && locationId) ? <MenuItem
              key="edit"
              style={{ fontSize: '15px', minHeight: '32px', lineHeight: '32px' }}
              innerDivStyle={{ padding: '0px 24px 0px 64px' }}
              primaryText="Edit"
              onTouchTap={actionsForContractWindow.createNGoToDraft}
              leftIcon={<FontIcon
                className="tc-icon-mode_edit"
                style={{
                  top: '4px',
                  margin: '0',
                  left: '24px',
                  fill: 'rgb(117, 117, 117)',
                }}
              />}
            /> : undefined
          }
          {
            Boolean(viewingAs === 'Buyer' && locationId) ? <MenuItem
              key="makeACopy"
              style={{ fontSize: '15px', minHeight: '32px', lineHeight: '32px' }}
              innerDivStyle={{ padding: '0px 24px 0px 64px' }}
              primaryText="Make A Copy"
              onClick={() => actionsForContractWindow.openDialogSaveAsTemplate({
                contractId,
                contractYear: { startDate, endDate },
                templateId,
                isDummyTemplate: templateFromDummy,
              })}
              leftIcon={<FontIcon
                className="tc-icon-content_copy"
                style={{
                  top: '4px',
                  margin: '0',
                  left: '24px',
                  fill: 'rgb(117, 117, 117)',
                }}
              />}
            /> : undefined
          }
          {
            !amended && ((viewingAs === 'Supplier' && locationId) || (viewingAs === 'Buyer' && !locationId)) ? <MenuItem
              key="Resend"
              style={{ fontSize: '15px', minHeight: '32px', lineHeight: '32px' }}
              innerDivStyle={{ padding: '0px 24px 0px 64px' }}
              primaryText="Resend"
              onTouchTap={actionsForContractWindow.resendContract}
              leftIcon={<FontIcon
                className="tc-icon-near_me"
                style={{
                  top: '4px',
                  margin: '0',
                  left: '24px',
                  fill: 'rgb(117, 117, 117)',
                }} />}
            /> : undefined
          }
          {
            Boolean(viewingAs === 'Buyer' && !locationId) && <ContractMailbox contractId={contractId} />
          }
          {
            Boolean(viewingAs === 'Buyer' && locationId) && <ExportTourWriter contractId={contractId} />
          }
          {
            Boolean(viewingAs === 'Buyer' && locationId) && <ExportTourWriter contractId={contractId} blackout />
          }
        </IconMenu>,
        locationId ? (
          <WallWrapper amazonOrange key="compare">
            <FlatButton
              label="Compare with"
              labelStyle={{ textTransform: 'none', paddingRight: '8px' }}
              hoverColor="rgba(0, 0, 0, 0.15)"
              style={{ color: textColor, minWidth: '68px' }}
              onTouchTap={() => push(`/contracting/reports/diff/contract/${contractId}?${querystring.stringify({
                locationId,
                buyerId,
                email,
                locationName,
                companyName: titleName,
              })}`)}
              icon={<FontIcon className="tc-icon-swap_horiz" style={{ color: textColor, fontSize: '22px', marginLeft: '8px' }} />}
            />
          </WallWrapper>
        ) : undefined,
        viewingAs === 'Buyer' && acceptedOrLoaded && tourPlanUser ? <FlatButton
          key="Export"
          label="Export"
          labelStyle={buttonLabelStyle}
          hoverColor="rgba(0, 0, 0, 0.15)"
          style={buttonStyle}
          onTouchTap={() => push(`/integration/product-mapping/${contractId}`)}
          icon={<ExportIcon style={{ color: textColor, fontSize: '22px', marginLeft: '8px' }} />}
        /> : undefined,
        locationId ? <FlatButton
          key="Download"
          label="Download"
          labelStyle={buttonLabelStyle}
          hoverColor="rgba(0, 0, 0, 0.15)"
          style={buttonStyle}
          onTouchTap={(e) => actionsForContractWindow.downloadContractPdf(contractId, contractState, e.currentTarget)}
          icon={<FontIcon className="tc-icon-get_app" style={{ color: textColor, fontSize: '22px', marginLeft: '8px' }} />}
        /> : undefined,
        <FlatButton
          key="Activities"
          hoverColor="rgba(0, 0, 0, 0.15)"
          disabled={routeName === 'activities'}
          backgroundColor={routeName === 'activities' ? 'rgba(0, 0, 0, 0.15)' : 'transparent'}
          labelStyle={buttonLabelStyle}
          style={buttonStyle}
          onTouchTap={() => actionsForContractWindow.changeLeftNavRoute(`/contracting/contract/${contractId}/activities`)}
        >
          <div style={{ display: 'flex', paddingRight: '8px' }}>
            <div style={{ position: 'relative', top: '4px', width: '40px' }}>
              <FontIcon className="tc-icon-question_answer" style={{ color: textColor, fontSize: '22px', marginLeft: '8px' }} />
              {Boolean(hasNewComments && routeName !== 'activities') && <RedDot/>}
            </div>
            <span>Activities</span>
          </div>
        </FlatButton>,
        <WallWrapper amazonOrange key="internal-notes">
          <FlatButton
            label="Internal Notes"
            hoverColor="rgba(0, 0, 0, 0.15)"
            disabled={routeName === 'notes'}
            backgroundColor={routeName === 'notes' ? 'rgba(0, 0, 0, 0.15)' : 'transparent'}
            labelStyle={buttonLabelStyle}
            style={buttonStyle}
            onTouchTap={() => actionsForContractWindow.changeLeftNavRoute(`/contracting/contract/${contractId}/notes`)}
            icon={(<InternalNoteIcon
              style={{ color: textColor, fontSize: '22px', marginLeft: '8px', marginBottom: '5px' }}
            />)}
          />
        </WallWrapper>,
      ])}
    >
      {children}
    </Window>
  );
};

const mapStateToProps = ({ contracting, user, config, routing }, { reducerName }) => {
  const leftNav = contracting[reducerName].get('leftNav').toJS();
  const rightContent = contracting[reducerName].get('rightSideContent').toJS();
  return {
    companyType: user.getIn(['user', 'type']),
    userId: user.get('id'),
    apiUrl: config.get('apiUrl'),
    tourPlanUser: user.getIn(['company', 'tourplan']) ? Boolean(user.getIn(['company', 'tourplan']).password) : false,
    ...leftNav,
    productName: rightContent.productName,
    productId: rightContent.productId,
    productType: rightContent.productType,
    routePath: routing.locationBeforeTransitions.pathname,
    pureDocView: user.get('pureDocView'),
  };
};

export default connect(mapStateToProps, {
  push: pushAction,
  requestDataLoading: payload => ({ type: 'OPEN_REQUEST_DL', payload }),
  openRateDocIframe: payload => ({
    type: '{dummy-account} RateDocIframe_open',
    payload,
  }),
})(WindowDataWrapper);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/contract-window.jsx